<div class="card col-md-8">
  <div class="card-body">
    <form #form="ngForm" name="form" (ngSubmit)="submit()">
      <h5 class="card-title">Security Checkpoint</h5>
      <hr />
      <div class="row">
        <div class="col-md-4">
          <h6>Checkpoint</h6>
          <spk-text [name]="'commandName'" [placeholder]="" [disabled]="true" [(model)]="model.CommandName" [wrapped]="false" [group]="true" [groupButtonIcon]="'search'"
            (groupButtonClick)="showCheckpointLookup()" [groupButtonClass]="'btn btn-primary'" [groupButtonDisabled]="false"></spk-text>

          <spk-text [name]="'description'" [autoComplete]="false" [(model)]="model.Description"></spk-text>
        </div>
        <div class="col-md-4">
          <h6>Roles</h6>
          <spk-value-text-checkboxlist [(model)]="roles"></spk-value-text-checkboxlist>
        </div>
      </div>
    </form>
  </div>
</div>
<spk-modal-lookup *ngIf="model.Id == 0" [id]="'checkpointLookup'" [list]="null" [title]="'Security Checkpoint Lookup'" [sort]="'CommandName'" [command]="'UnusedSecurityCheckpointSearch'"
  (rowSelected)="checkpointSelected($event)">
</spk-modal-lookup>